var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-text"},[_c('v-skeleton-loader',{attrs:{"loading":_vm.loading,"max-width":_vm.maxWidth,"type":"paragraph"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }